import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const CameraIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M15.1714 0.771429H2.82857C1.69244 0.771429 0.771429 1.69244 0.771429 2.82857V15.1714C0.771429 16.3076 1.69244 17.2286 2.82857 17.2286H15.1714C16.3076 17.2286 17.2286 16.3076 17.2286 15.1714V2.82857C17.2286 1.69244 16.3076 0.771429 15.1714 0.771429Z" stroke={color} strokeWidth="1.5" />
  </Svg>
);

CameraIcon.displayName = 'CameraIcon';
